import { createSlice } from '@reduxjs/toolkit';
const unsavedChangesSlice = createSlice({
  name: 'unsavedChanges',
  initialState: {
    hasImportantUnsavedChanges: false
  },
  reducers: {
    setHasImportantUnsavedChanges: (state, action) => {
      state.hasImportantUnsavedChanges = action.payload;
    }
  }
});
export const {
  setHasImportantUnsavedChanges
} = unsavedChangesSlice.actions;
export default unsavedChangesSlice.reducer;